
// NovoUsuarioPage.js

import React, { useState } from 'react';
//import Axios from 'axios';
import api from '../../config/axiosConfig';
import { useNavigate } from 'react-router-dom';

function CadastroNovoUsuPage() {
  const [username, setUsername] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [fone, setFone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();

    // Verificar se todos os campos estão preenchidos
    if (!username || !name || !email || !fone || !password) {
      setError('Todos os Campos devem ser preenchidos');
      return;
    }

try {
const response = await api.post('/usuarios/cadastrar', {
    username,
    name,
    email,
    fone,
    password,
    role: 'USER', // Definindo o valor 'USER' para o campo role
    enabled: true, // Definindo o valor true para o campo enabled
});
  
  // Manipular a resposta da API
  const newUser = response.data;
  console.log('Novo usuário cadastrado:', newUser);
  navigate('/login'); // Redireciona para a página de login após cadastro
  window.alert('Cadastro realizado com sucesso');
} catch (error) {
  if (!error.response) {
    setError('Erro ao acessar o servidor');
  } else if (error.response.status === 400) {
    if (error.response.data.includes('Nome de Usuário')) {
      setError('O Nome de Usuário já está em uso');
    } else if (error.response.data.includes('Email fornecido é inválido')) {
      setError('O Email fornecido é inválido');
    } else if (error.response.data.includes('Email fornecido já está em uso')) {
      setError('O Email fornecido já está em uso');
    }
  } else {
    setError('Erro desconhecido. Tente novamente.');
  }
    }
    
};

  return (
    <div className="login-alfatek">
      <div>
        <h2>Novo Usuário - Alfatek</h2>
        <form className="login-form" onSubmit={handleSignup}>
          <input
            type="text"
            name="username"
            placeholder="Usuário"
            required
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="off"
          />
          <input
            type="text"
            name="name"
            placeholder="Nome Completo"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoComplete="off"
          />
          <input
            type="text"
            name="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="off"
          />
          <input
            type="text"
            name="fone"
            placeholder="Telefone ou Celular"
            required
            value={fone}
            onChange={(e) => setFone(e.target.value)}
            autoComplete="off"
          />
          <input
            type="password" // Mudar para type="password"
            name="password"
            placeholder="Senha"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
          />
          <button type="submit" className="btn-login">
            Cadastrar
          </button>
        </form>
        <p>{error}</p>
      </div>
    </div>
  );
}

export default CadastroNovoUsuPage;